<template>
  <div class="d-flex justify-content-between align-items-center mb-2 p-3" :class="{'configGroupItem--active': isConfigured}">
    <div class="d-flex">
      <input
        v-if="configType === 'input'"
        :value="itemQuantity"
        @change="onQuantityChange"
        class="mr-2 configGroupItem--input"
        :id="`config-group-item-${kKonfigitem}`"
        type="number"
        :min="0"
        :max="fMax"
      />


      <input
        v-if="configType === 'checkbox'"
        @change="checkboxChange"
        class="mr-2"
        :id="`config-group-item-${kKonfigitem}`"
        :name="`config-group-item-${configGroupId}`"
        type="checkbox"
        :value="kKonfigitem"
      />

      <input
        v-if="configType === 'radio'"
        @change="onSelectableInputChanged"
        class="mr-2"
        :value="kKonfigitem"
        :id="`config-group-item-${kKonfigitem}`"
        :name="`config-group-item-${configGroupId}`"
        type="radio"
        v-model="selectedRadio"
      />

      <label class="configGroupItem--label m-auto" :for="`config-group-item-${kKonfigitem}`" v-html="cName"></label>
    </div>
    <span class="font-weight-bold configGroupItem--price" v-html="fPreisLocalized[0]"></span>
  </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import {onSelectableInputChanged} from "../composable/onSelectableInputChanged";
export default {
  name: "ConfigGroupItem",
  props: {
    props: ['selectedItem'],
    configGroupItem: {
      type: [String, Number],
      required: true,
    },
    configType: {
      default: 'input',
    }
  },
  setup(props) {
    const store = useStore();
    const groupForItem = store.getters.getConfigGroupForConfigItem(props.configGroupItem);
    const item = store.state.articleConfigGroupItems[props.configGroupItem];

    if(!item) {
      throw new Error(`Unkown item ${props.configGroupItem}`);
    }

    const itemQuantity = computed(() => store.state.currentConfiguration.configurationItems[props.configGroupItem] || 0);

    const isSelected = computed(() => store.state.currentConfiguration.configurationItems[props.configGroupItem] === 1);

    const selectedRadio = computed(() => groupForItem.oItem_arr.find((itemId) => store.state.currentConfiguration.configurationItems[itemId] === 1));
    watch(isSelected, (hasBeenSelected) => {
      store.dispatch('updateConfigurationItem', {
        id: item.kKonfigitem,
        quantity: hasBeenSelected ? 1 : 0,
      });
    });

    return {
      item,
      ...item,
      configGroupId: groupForItem.kKonfiggruppe,
      itemQuantity,
      selectedRadio,
      isSelected,
      isConfigured: computed(() => {
        return itemQuantity.value > 0;
      }),

      onSelectableInputChanged(e) {
        onSelectableInputChanged(e.target.value, groupForItem);
      },
      onQuantityChange(e) {
        store.dispatch('updateConfigurationItem', {
          id: props.configGroupItem,
          quantity: parseInt(e.target.value, 10),
        });
      },
      checkboxChange(e) {
        store.dispatch('updateConfigurationItem', {
          id: e.target.value,
          quantity: e.target.checked ? 1 : 0,
        });
      },
      onSelectedItem(e) {
        store.dispatch('updateConfigurationItem', {
          id: e.target.value,
          quantity: 1,
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
$highlightColor: #32B0F9;

.config-group-row > .card > .card-body > div:nth-of-type(even) {
  background: var(--unnamed-color-f2f2f2) 0% 0% no-repeat padding-box;
  background: #F2F2F2 0% 0% no-repeat padding-box;
}


.configGroupItem--active {
  .configGroupItem--input {
    border-color: $highlightColor !important;
  }

  .configGroupItem--input,
  .configGroupItem--label,
  .configGroupItem--price {
    color: $highlightColor !important;
  }
}
</style>